import { Button } from "@material-ui/core";
import appConstant from "common/constants/appConstant";
import { formatDigits, getCurrencyPrefix, getEnvVar } from "common/utilities/ generic";
import { sendAnalyticsOnEvent } from "common/utilities/analytics";
import { getQuoteClickedMapping } from "common/utilities/analytics/config/mappings/eventDataLayerMappings";
import logger from "common/utilities/logger";
import PopOver from "components/common/FormControls/PopOver/popover";
import Footer from "components/footer";
import Header from "components/header";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader } from "redux/actions";

const Quote = () => {
    const dispatch = useDispatch();

    const { sdkConfig, cmsData, petQuote } = useSelector((state) => state.userDetails);

    const {
        styles = {
            button: {
                active: {},
            },
        },
        label = {
            button: {
                buttonTextStep2: "",
            },
        },
        showAppLogo = true,
        queryParams = "",
    } = sdkConfig;

    const {
        step2_heading,
        step2_sub_heading,
        per_month,
        max_annual_payout,
        annual_deductible,
        reimbursement_rate,
        checklist,
        checklist_can,
        see_quote_details,
        info_icon,
        max_annual_payout_content,
        annual_deductible_content,
        reimbursement_rate_content,
        max_annual_payout_content_can,
        annual_deductible_content_can,
        reimbursement_rate_content_can,
        act_now_banner,
    } = cmsData;

    const country = get(petQuote, "countryCode", "");
    const currency = getCurrencyPrefix(country);
    const countryWiseChecklist = country === appConstant.COUNTRY_CODE_US ? checklist : checklist_can;
    const promoCode = get(petQuote, "pets[0].quotes[0].campaignDetails.code", false);
    const campaignDetails = get(petQuote, "pets[0].quotes[0].campaignDetails", false);
    const promoCodeDescription = get(petQuote, "pets[0].quotes[0].campaignCodeDescription", false);
    const isStrikeThroughText =
        campaignDetails &&
        campaignDetails.code != null &&
        (campaignDetails.discountType.length === 0 || campaignDetails.discountType === null);

    const setHideLoader = () => {
        dispatch(hideLoader({ isLoading: false }));
    };

    const getOriginalPrice = (data) => {
        const price = data?.quotes[0]?.taxAndServicePremium?.monthly || 0;

        const formatePrice = formatDigits(price.toFixed(2));

        return { formatePrice };
    };

    const triggerPageLoadGTM = () => {
        const mapping = getQuoteClickedMapping(petQuote);

        sendAnalyticsOnEvent(mapping);
    };

    const getDiscountAnnualPrice = (data) => {
        const taxAndServicePremium = get(data, "quotes[0].taxAndServicePremium.annually", 0);
        const discountTaxAndServicePremium = get(data, "quotes[0].discountTaxAndServicePremium.annually", 0);

        const discountPrice = `${getCurrencyPrefix(country)}${(
            Number(taxAndServicePremium) - Number(discountTaxAndServicePremium)
        ).toFixed(2)}`;

        return discountPrice?.replace(appConstant.DIGIT_EXPRESSION, "$1,");
    };

    const getDiscountedPrice = (data) => {
        const price = data?.quotes[0]?.discountTaxAndServicePremium?.monthly || 0;

        const [match, wholeDigits, decimalDigits] = String(price.toFixed(2)).match(appConstant.PRICE_EXPRESSION) || [];

        const formateDigit = formatDigits(wholeDigits);

        const priceLength = parseFloat(price).toFixed(2).split(".")[0].length;

        return { formateDigit, decimalDigits, priceLength };
    };

    const getCoverageDetails = (item) => {
        const { annualPolicyMaximumLimit, annualDeductibleDollarAmount, coPayPercentage } = item.quotes[0];

        const annualLimit =
            annualPolicyMaximumLimit === appConstant.PAYOUT_DETAILS_UNLIMITED
                ? `${formatDigits(annualPolicyMaximumLimit)}`
                : `${currency}${formatDigits(annualPolicyMaximumLimit)}`;

        return {
            annualLimit,
            annualDeductible: `${currency}${formatDigits(`${annualDeductibleDollarAmount}`.toString())}`,
            coPayPercentage,
        };
    };

    const handleSubmit = () => {
        logger.info("User click on See quote details button", petQuote?.customerId);

        const BUY_URL = getEnvVar("REACT_APP_BUY_QUOTE_URL");

        const params = queryParams
            ? `${queryParams}&prospectId=${petQuote?.customerId}`
            : `?prospectId=${petQuote?.customerId}`;

        const URL = `${BUY_URL}${params}`;

        window.open(URL);
    };

    useEffect(() => {
        setHideLoader();

        const filterCartLineIdFromCart = petQuote.pets.map((item) => {
            return {
                cartLineItemId: item?.cartLineItemId,
                petName: item?.petName,
                id: item?.id,
                effectiveDate: item?.quotes[0]?.effectiveDate,
                effectiveDateTime: item?.quotes[0]?.effectiveDateTime,
                enrollmentFee: item?.quotes[0]?.enrollmentFee,
                petModelLawConfig: petQuote?.petModelLawConfig,
            };
        });

        logger.info("Quote page loading successfully with Cart API response:", filterCartLineIdFromCart);

        triggerPageLoadGTM();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [petQuote]);

    const isDiscounted =
        promoCode && !isStrikeThroughText && promoCodeDescription
            ? `quote-container__coverage-container__price-container__discounted-price-${country}`
            : "";

    return (
        <>
            {showAppLogo && <Header />}
            <div className="quote-container">
                {petQuote &&
                    petQuote?.pets?.map((item, index) => {
                        return (
                            <div key={index}>
                                <div className="quote-container__heading">
                                    {`${step2_heading} `}
                                    {item?.petName}
                                </div>
                                <div className="quote-container__sub-heading">{step2_sub_heading}</div>
                                {promoCode && !isStrikeThroughText && promoCodeDescription && (
                                    <div className="quote-container__discounted-container">
                                        {act_now_banner?.replace("${price}", getDiscountAnnualPrice(item))}
                                    </div>
                                )}
                                <div
                                    className={`${
                                        promoCode && !isStrikeThroughText && promoCodeDescription
                                            ? "quote-container__coverage-container quote-container__discounted-section"
                                            : "quote-container__coverage-container"
                                    } `}
                                >
                                    <div className="quote-container__coverage-container__price-container">
                                        {promoCode && !isStrikeThroughText && promoCodeDescription && (
                                            <div
                                                className={`quote-container__coverage-container__price-container__discount-${country}`}
                                            >
                                                {`${currency}${getOriginalPrice(item).formatePrice}`}
                                            </div>
                                        )}
                                        <div
                                            className={`quote-container__coverage-container__price-container__regular-${country} ${isDiscounted}`}
                                        >
                                            <div
                                                className={`${
                                                    getDiscountedPrice(item).priceLength > 2 ? "price-large" : "price"
                                                }`}
                                            >
                                                <div className="price-main-div">
                                                    <div className="currency">{currency}</div>
                                                    <div className="whole-number">
                                                        {getDiscountedPrice(item).formateDigit}
                                                    </div>
                                                    <div className="decimal-and-month">
                                                        <div className="decimal-number">
                                                            .{getDiscountedPrice(item).decimalDigits}{" "}
                                                        </div>

                                                        <div className="per-month">{per_month}</div>
                                                    </div>
                                                </div>

                                                <div className="per-month-below">
                                                    <div className="per-month">{per_month}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="quote-container__coverage-container__plan-details">
                                        <div className="recommend-plan-content-col">
                                            <div className="top">
                                                <span>
                                                    {max_annual_payout}
                                                    <PopOver
                                                        content={
                                                            country === appConstant.COUNTRY_CODE_US
                                                                ? max_annual_payout_content
                                                                : max_annual_payout_content_can
                                                        }
                                                        className="popover-container"
                                                    >
                                                        <img src={info_icon?.url} alt={info_icon.alt} />
                                                    </PopOver>
                                                </span>
                                            </div>
                                            <div className="bottom">
                                                <span>{getCoverageDetails(item).annualLimit}</span>
                                            </div>
                                        </div>
                                        <div className="rule"></div>
                                        <div className="recommend-plan-content-col">
                                            <div className="top">
                                                <span>
                                                    {annual_deductible}
                                                    <PopOver
                                                        content={
                                                            country === appConstant.COUNTRY_CODE_US
                                                                ? annual_deductible_content
                                                                : annual_deductible_content_can
                                                        }
                                                        className="popover-container"
                                                    >
                                                        <img src={info_icon?.url} alt={info_icon.alt} />
                                                    </PopOver>
                                                </span>
                                            </div>
                                            <div className="bottom">
                                                <span>{getCoverageDetails(item).annualDeductible}</span>
                                            </div>
                                        </div>
                                        <div className="rule"></div>
                                        <div className="recommend-plan-content-col">
                                            <div className="top">
                                                <span>
                                                    {reimbursement_rate}
                                                    <PopOver
                                                        content={
                                                            country === appConstant.COUNTRY_CODE_US
                                                                ? reimbursement_rate_content
                                                                : reimbursement_rate_content_can
                                                        }
                                                        className="popover-container"
                                                    >
                                                        <img src={info_icon?.url} alt={info_icon.alt} />
                                                    </PopOver>
                                                </span>
                                            </div>
                                            <div className="bottom">
                                                <span>{`${getCoverageDetails(item).coPayPercentage}%`}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                <div className="quote-container__check-list">
                    {countryWiseChecklist?.map((item, index) => {
                        return (
                            <div className="quote-container__check-list__container" key={index}>
                                <img src={item.icon.url} alt={item.icon.alt} />
                                <div className="text">{item.text}</div>
                            </div>
                        );
                    })}
                </div>
                <div className="quote-container__button">
                    <Button
                        type="button"
                        size="large"
                        onClick={handleSubmit}
                        variant="contained"
                        id="submit"
                        style={{ ...styles?.button?.active }}
                    >
                        {label?.button?.buttonTextStep2 || see_quote_details}
                    </Button>
                </div>
            </div>
            <Footer />
        </>
    );
};

Quote.propTypes = {};

export default Quote;
